import type { MbtiCode } from './types';

/**
 * 下部CTAボタン文言（キャラごとに固有）
 * 新規タイプ追加時はここに1行追加するか、{code}.ts で cta を上書き
 */
export const DIAGNOSIS_RESULT_CTA: Record<MbtiCode, string> = {
  PALE: '名店予約と食べ歩きルートを自動で組む旅程作成',
  PALZ: '予約前提で「ゆったり美食導線」を自動で組む旅程作成',
  PACE: '食の名店を効率よく制覇する弾丸グルメ旅程を自動作成',
  PACZ: '安心・確実な定番コースで組むストレスフリー旅程作成',
  PRLE: '計画型でグルメ名店を攻めるハンター旅程を自動作成',
  PRLZ: '予約前提で「のんびり美食旅」を自動で組む旅程作成',
  PRCE: '食も観光もバランスよく組む探検型旅程を自動作成',
  PRCZ: '無理のない快適ペースで組むほどほど旅程を自動作成',
  SALE: '即興でも回れる爆速動線の旅程を自動作成',
  SALZ: 'ビーチと癒しを軸にしたマイペース旅程を自動作成',
  SACE: '「面白そう」を拾うゆるアクティブ旅程を自動作成',
  SACZ: '宿とカフェ中心の超スロー旅程を自動で組む',
  SRLE: '屋台と冒険グルメを詰め込んだ食い倒れ旅程を自動作成',
  SRLZ: '路地裏グルメを巡る放浪食旅ルートを自動作成',
  SRCE: 'ノープランでも迷わない自由な旅の土台を自動作成',
  SRCZ: '自分ペースで組める超ゆったり旅程を自動作成',
};

export function getDiagnosisResultCta(code: MbtiCode): string {
  return DIAGNOSIS_RESULT_CTA[code];
}
